import React, { useState } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css"; // reuse same CSS

export default function SignupPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();

    try {
      await API.post("/lead/signup", {
        name,
        email,
        password,
        phone_number,
      });

      alert("Account created successfully");
      navigate("/");

    } catch (err) {
      alert(err.response?.data?.message || "Signup failed");
    }
  };

  return (
    <div className="login-wrapper">

      {/* LEFT IMAGE */}
      <div className="login-left">
        <img src="/Side-img.png" alt="Attendance Illustration" />
      </div>

      {/* RIGHT FORM */}
      <div className="login-right">
        <img src="/Softmate-Logo.png" className="logo" alt="Softmate" />

        <form onSubmit={handleSignup} className="login-form">
          <h1 style={{ textAlign: "center" }}>Sign Up</h1>

          {/* Name */}
          <div className="form-group">
            <label>Full Name</label>
            <div className="input-box">
              <span className="icon">👤</span>
              <input
                type="text"
                placeholder="Enter Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Email */}
          <div className="form-group">
            <label>Email ID</label>
            <div className="input-box">
              <span className="icon">📧</span>
              <input
                type="email"
                placeholder="Enter Email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Phone */}
          <div className="form-group">
            <label>Phone Number</label>
            <div className="input-box">
              <span className="icon">📱</span>
              <input
                type="text"
                placeholder="Enter Phone Number"
                value={phone_number}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          </div>

          {/* Password */}
          <div className="form-group">
            <label>Password</label>
            <div className="input-box">
              <span className="icon">🔑</span>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                style={{ cursor: "pointer" }}
              >
                {showPassword ? "🙈" : "👁️"}
              </span>
            </div>
          </div>

          <button type="submit">Sign Up</button>

          <p style={{ textAlign: "center", marginTop: "15px" }}>
            Already have an account?{" "}
            <span
              style={{ color: "#007bff", cursor: "pointer" }}
              onClick={() => navigate("/")}
            >
              Login Here
            </span>
          </p>

        </form>
      </div>

    </div>
  );
}
